import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            影视分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            八大影视分类，快速找到你想看的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href={`#carousel`}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200 hover:border-primary-200 cursor-pointer transition-all duration-200 no-underline"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors mb-3">
                <i className={`${item.icon} text-lg md:text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 whitespace-nowrap mb-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-2 text-center">
                {item.description}
              </p>
              <span className="text-xs text-primary-500 font-medium">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}